<template>
  <td class="content-type-cell">
    {{ title }}
  </td>
</template>
<script>
import TableCellMixin from "./TableCellMixin.js";

export default {
  mixins: [TableCellMixin],
  created() {
    this.$glossary.ensure();
  },
  computed: {
    lookup() {
      return this.$glossary.hash;
    },
    match() {
      return this.lookup ? this.lookup[this.value] : null;
    },
    title() {
      return this.match?.title || this.value;
    },
    plural() {
      return this.match?.plural || this.title;
    },
    rendered() {
      return this.column.plural ? this.plural : this.title;
    },
  },
};
</script>
<style lang="scss" scoped>
.content-type-cell {
  white-space: nowrap;
}
</style>
